module.exports = fox._r("images/ad-favorites_hover.png", __webpack_public_path__ + "images/ad-favorites_hover.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/ad-favorites_hover.png
// module id = 967
// module chunks = 4